import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  JwtRefresher,
  Pagination,
  PaginationContainer,
} from '@white-nl/instantsearch-components';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import SearchkitClient from '@searchkit/instantsearch-client';
import {
  Configure,
  InstantSearch,
} from 'react-instantsearch';
/* eslint-disable-next-line import/no-extraneous-dependencies */
import Hits from '../results/Products';
import ProductFilters from '../filters/ProductFilters';
import { useGetCatalogTranslatesQuery } from '../../redux-modules/service';

export default function ProductOverview({
  productsIndexName,
  productsPublicUrl,
  refreshUrl,
  locale,
  categoryUri,
  categoryTitle,
  siteId,
  loadingText,
}) {
  const [
    currentSearchClient,
    setCurrentSearchClient,
  ] = useState(null);

  const [currentCategory, setCurrentCategory] = useState(categoryUri);

  const {
    data: translatesData,
    isFetching: isTranslatesDataFetching,
  } = useGetCatalogTranslatesQuery();

  if (isTranslatesDataFetching || translatesData.translates.length === 0) {
    return loadingText;
  }

  let defaultFilters = `siteId:${siteId}`;

  if (currentCategory) {
    defaultFilters = `${defaultFilters} AND productCategory:"${currentCategory}"`;
  }

  const additionalData = {
    locale,
    productsIndexName,
    currentSite: siteId,
    currentCategory,
    categoryTitle,
    onCategoryChanged: setCurrentCategory,
    translates: translatesData.translates,
  };

  const {
    catalog,
  } = translatesData.translates;

  const jwtRefresher = (
    <JwtRefresher
      cookieName="elasticsearch_token"
      checkIntervalSeconds={5}
      refreshTimeBeforeExpirySeconds={30}
      refreshIframeUrl={refreshUrl}
      onRefreshed={(token) => {
        const config = {
          url: productsPublicUrl,
          headers: {
            authorization: `Bearer ${token}`,
          },
        };
        const searchKitClient = Object.assign(SearchkitClient(config), {
          transporter: {
            headers: {
              'x-algolia-application-id': 'NULL',
              'x-algolia-api-key': 'NULL',
            },
          },
        });
        setCurrentSearchClient(searchKitClient);
      }}
    />
  );

  if (!currentSearchClient) {
    return jwtRefresher;
  }

  const hitsPerPage = 12;

  return (
    <>
      {jwtRefresher}
      <InstantSearch
        indexName={productsIndexName}
        searchClient={currentSearchClient}
        future={{
          preserveSharedStateOnUnmount: true,
        }}
      >
        <Configure
          hitsPerPage={hitsPerPage}
          filters={defaultFilters}
        />

        <div className="section-head">
          <div className="row align-items-center">
            <div className="col-12 col-lg-6">
              <h2>{Craft.t(catalog, 'Looking for product support?')}</h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12 col-lg-3">
            <ProductFilters
              indexName={productsIndexName}
              currentCategory={currentCategory}
              onCategoryChanged={setCurrentCategory}
              additionalData={additionalData}
            />
          </div>
          <div className="col-12 col-lg-9">
            <div className="card-product-wrap row">
              <Hits additionalData={additionalData} />
              <PaginationContainer
                paginationComponent={Pagination}
                paginationSettings={{
                  classNames: {
                    list: 'pagination',
                    item: 'page-item',
                    selectedItem: 'active',
                    disabledItem: 'disabled',
                    link: 'page-link',
                  },
                  enableCanonicalUpdates: true,
                  showFirst: false,
                  showLast: false,
                }}
                additionalData={additionalData}
              />
            </div>
          </div>

        </div>
      </InstantSearch>
    </>
  );
}

ProductOverview.propTypes = {
  productsIndexName: PropTypes.string,
  productsPublicUrl: PropTypes.string,
  refreshUrl: PropTypes.string,
  locale: PropTypes.string,
  categoryUri: PropTypes.string,
  categoryTitle: PropTypes.string,
  loadingText: PropTypes.string,
  siteId: PropTypes.number,
};
